import styles from "./input.module.scss";
import {
  FieldValues,
  Path,
  PathValue,
  useController,
  UseControllerProps
} from "react-hook-form";
import {
  HTMLInputAutoCompleteAttribute,
  HTMLInputTypeAttribute,
  KeyboardEvent,
  ClipboardEvent,
  useState
} from "react";
import eye from "../../images/eye.svg";
import eyeCrossed from "../../images/eyeСrossed.svg";

type InputProps<T extends FieldValues> = {
  type?: HTMLInputTypeAttribute;
  disabled?: boolean;
  error?: string;
  autoComplete?: HTMLInputAutoCompleteAttribute;
  maxLength?: number;
  placeholder?: string;
} & UseControllerProps<T>

export const Input = <T extends FieldValues>({ disabled, control, name, error, autoComplete, maxLength, type, placeholder }: InputProps<T>) => {
  const {
    field: { ref, ...inputControl },
  } = useController({
    name,
    control,
    defaultValue: "" as PathValue<T, Path<T>>
  });

  const [showPassword, setShowPassword] = useState(type !== "password");

  const onlyInteger = (event: KeyboardEvent<HTMLInputElement>) => {
    if (type === "number") {
      if (!/[0-9]/.test(event.key) && event.key !== "Backspace" && event.key !== "Delete") {
        event.preventDefault();
      }
    }
  }
  const pasteInteger = (event: ClipboardEvent<HTMLInputElement>) => {
    if (type === "number") {
      let paste = event.clipboardData.getData('text');
      if (/[^0-9]/.test(paste)) {
        event.preventDefault();
      }
    }
  }

  const onClickEye = (): void => {
    setShowPassword(!showPassword);
  }

  return (
    <div className={styles.container}>
      <input type={showPassword ? "text" : "password"}
             className={error ? styles.error : ""}
             autoComplete={autoComplete}
             onKeyPress={onlyInteger}
             placeholder={placeholder}
             onPaste={pasteInteger}
             maxLength={maxLength}
             ref={ref}
             {...inputControl}
             disabled={disabled}/>
      {error && <p className={styles.errorMessage}> {error}</p>}
      {type === "password" && (<div className={styles.eye} onClick={onClickEye}><img src={showPassword ? eyeCrossed : eye} alt=""/></div>)}
    </div>
  )
}
